import { BlockComponentFactory } from '../BlockFactory'
import Input from 'antd/lib/input'
import { TextInputBlockProps } from './block-props.types'
import { LabelBlock } from './LabelBlock'
import { LABEL_FONT_STYLE } from '../../constants'
import { useBlockListeners } from '../BlockHooks'
import { useBlockEngine } from '../BlockEngineContext'
import { toCSSSize } from './block-utils'

const INPUT_STYLE: React.CSSProperties = {
    ...LABEL_FONT_STYLE,
    fontSize: '12px',
}

export const TextInputBlockComponent =
    BlockComponentFactory.createBlockComponent<TextInputBlockProps>(props => {
        const {
            label,
            placeholder,
            infoText,
            visibility = 'visible',
            disabled = false,
            required = false,
            minLength,
            maxLength,
            showCount = false,
            width,
            style,
            value,
        } = props

        const isEditable = useBlockEngine().blockEngine.getEditableSignal().value

        const [onChangeListener] = useBlockListeners<(value: string | null) => void>('onChange')

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: toCSSSize(width) ?? 'auto',
        }

        return (
            <div style={containerStyle}>
                <LabelBlock
                    label={label}
                    required={required}
                    infoText={infoText}
                    labelStyle={LABEL_FONT_STYLE}
                />
                <Input
                    placeholder={placeholder}
                    onChange={e => onChangeListener?.value?.(e.target.value)}
                    value={value}
                    required={required}
                    minLength={minLength}
                    maxLength={maxLength}
                    showCount={showCount}
                    style={INPUT_STYLE}
                    disabled={!isEditable || disabled}
                />
            </div>
        )
    })
